import constants from '@/config/constants';
import { callApi } from '@/services/CallApi.service';

const admin = {
    get: async (accessToken) => {


        const options = {
            url: `${constants.api.baseUrl}/admin/org`,
            method: 'GET',
        };

        return await callApi(options, accessToken);
    },
    update: async (accessToken, formData) => {

        const options = {
            url: `${constants.api.baseUrl}/admin/org`,
            method: 'PATCH',
        };

        const body = {
            name: formData.name,
            logoUrl: formData.logoUrl,
            primaryColor: formData.primaryColor,
            secondaryColor: formData.secondaryColor,
        };

        return await callApi(options, accessToken, body);
    },
}

const getBranding = async (accessToken) => {

    const options = {
        url: `${constants.api.baseUrl}/org/branding`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};

export default {
    admin,
    getBranding,
};
